<!--<mat-expansion-panel hideToggle [expanded]="!flujo.ok && !flujo.cargando">-->
<mat-expansion-panel hideToggle [expanded]="!flujo.ok && !ciValidado">

    <mat-expansion-panel-header>
        <mat-panel-title> Datos Personales </mat-panel-title>
        <mat-panel-description>
            <div *ngIf="(!flujo.ok && !flujo.cargando) && showCantidadCampos && ciValidado">
                <!--======informacion menu ======-->
                Completa sólo {{ calculaCantidadALlenar }} datos
            </div>
            <div *ngIf="flujo.cargando && ciValidado">
                <div class="spinner-border text-light" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div *ngIf="flujo.ok && !flujo.cargando && ciValidado">
                <!--======ok menu ======-->
                <img src="assets/icons/icon-check.svg" alt="ok" />
            </div>
        </mat-panel-description>
    </mat-expansion-panel-header>

    <!-- validacion c.i. -->
    <ng-container [formGroup]="datosCiForm" *ngIf="!ciValidado">
        <app-messages *ngIf="showInfoMessage" class="informativo mt-16 mb-16 p-16"
            message='<strong>El número de serie de tu Cédula de Identidad lo solicitamos por única vez</strong> para evitar suplantación y validar tus datos. <strong>Tu Cédula de Identidad debe estar vigente</strong> de lo contrario, si esta vencida no podrás continuar con el proceso de contratación.'>
        </app-messages>
        <div class="row">
            <div class="col-md-6 mt-36 txt-rut">
                <label for="txtRut" class="mb-0">RUT</label>
                <input tabindex="2" appFormatRut [ngClass]="{
                        inputValido: rutControl.valid,
                        inputInvalido:
                        (rutControl.invalid && rutControl.touched) ||
                        (rutControl.invalid && rutControl.dirty)
                    }" type="text" name="txtRut" formControlName="txtRut" placeholder="Ej: 123456789"
                    autocomplete="off" (focusout)="checkInputCI('txtRut')" [(ngModel)]="rut" disabled />
                <div *ngFor="let validation of messageRescatarDataError.txtRut">
                    <p *ngIf="rutControl.hasError(validation.type) && (rutControl.dirty || rutControl.touched)"
                        class="mensajeError mb-0">
                        {{ validation.message }}
                    </p>
                </div>
            </div>
            <div class="col-md-6 mt-36 numero-serie">
                <label for="numeroSerie" class="mb-0">Número de serie o documento</label>
                <div class="label-right" (click)="modalCiHelper()">Info &nbsp;<i class="informativo-blue"></i></div>
                <input tabindex="3" appFormatSerie [ngClass]="{
                        inputValido: serieControl.valid,
                        inputInvalido:
                        (serieControl.invalid && serieControl.touched) ||
                        (serieControl.invalid && serieControl.dirty)
                    }" type="text" id="txtSerie" name="txtSerie" formControlName="txtSerie" placeholder="Ej: 100000001"
                    autocomplete="off" (focusout)="checkInputCI('txtSerie')" />
                <div *ngFor="let validation of messageRescatarDataError.txtSerie">
                    <p *ngIf="serieControl.hasError(validation.type) && (serieControl.dirty || serieControl.touched)"
                        class="mensajeError mb-0">
                        {{ validation.message }}
                    </p>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-md-12 terminos-condiciones">
                <mat-checkbox [disabled]="rutControl.invalid || serieControl.invalid" tabindex="4"
                    formControlName="autorizacion">
                    He leído y acepto los <a href="{{urlTerminos}}" rel="noopener noreferrer" target="_blank">Términos y
                        condiciones</a> de Transbank.
                </mat-checkbox>
                <mat-checkbox [disabled]="rutControl.invalid || serieControl.invalid" tabindex="4"
                    formControlName="autorizacion2">
                    He leído y acepto la <a href="{{urlPrivacidad}}" rel="noopener noreferrer" target="_blank">Política
                        de privacidad</a> y autorizo a Transbank a hacer tratamiento de mis datos personales de acuerdo
                    a la Ley vigente.
                </mat-checkbox>
            </div>
        </div>
        <div class="row">
            <div *ngIf="authControl.dirty && !authControl.valid || authControl2.dirty && !authControl2.valid"
                class="col-md-12 box-mensaje-error">
                <app-messages class="error mt-16"
                    message="Es necesario aceptar los términos de condiciones y la política de privacidad para continuar"></app-messages>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <button tabindex="5" class="btn-primary-tbk button-float-right" type="submit" value="Validar"
                    (click)="Validar($event)"
                    [disabled]="rutControl.invalid || serieControl.invalid || authControl.invalid || authControl2.invalid">
                    <div *ngIf="loading" class="spinner-border text-light" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <div *ngIf="!loading">Continuar</div>
                </button>
            </div>
        </div>
    </ng-container>

    <!-- validacion datos personales -->
    <ng-container [formGroup]="datosPersonalesForm" *ngIf="!flujo.cargando && flujo.mostrar && ciValidado">
        <div class="row">
            <div class="col-md-6 mt-36">
                <label for="nombre">Nombre</label>
                <input appCaracteres [readonly]="(datosPersonalesResponse?.nombre.nombres || '') !== ''" type="text"
                    name="nombre" formControlName="nombre" placeholder="Ingresa nombre" autocomplete="off"
                    appMaxLength="50"
                    [class.inputInvalido]="datosPersonalesForm.get('nombre').invalid && datosPersonalesForm.get('nombre').touched"
                    required />
                <p *ngIf="(datosPersonalesForm.get('nombre').touched && datosPersonalesForm.get('nombre') === null)
                    || (datosPersonalesForm.get('nombre').touched && datosPersonalesForm.get('nombre').invalid)"
                    class="mensajeError">
                    {{ mensajeErrorDatosPersonales.REQUIRED_NAME_MESSAGE }}
                </p>
            </div>
            <div class="col-md-6 mt-36">
                <label for="primerApellido">Primer apellido</label>
                <input appCaracteres [readonly]="(datosPersonalesResponse?.nombre.apellidoPaterno || '') !== ''"
                    type="text" name="primerApellido" formControlName="primerApellido"
                    placeholder="Ingresa primer apellido" autocomplete="off" appMaxLength="50"
                    [class.inputInvalido]="datosPersonalesForm.get('primerApellido').invalid && datosPersonalesForm.get('primerApellido').touched"
                    required />
                <p *ngIf="(datosPersonalesForm.get('primerApellido').touched && datosPersonalesForm.get('primerApellido') === null)
                    || (datosPersonalesForm.get('primerApellido').touched && datosPersonalesForm.get('primerApellido').invalid)"
                    class="mensajeError">
                    {{ mensajeErrorDatosPersonales.REQUIRED_LASTNAME_MESSAGE }}
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mt-36">
                <label for="segundoApellido">Segundo apellido (opcional)</label>
                <input appCaracteres [readonly]="(datosPersonalesResponse?.nombre.apellidoMaterno || '') !== ''"
                    type="text" name="segundoApellido" formControlName="segundoApellido"
                    placeholder="Ingresa segundo apellido" appMaxLength="50" autocomplete="off" />
            </div>
            <!-- Existen dos DIV de nacionalidad ya que el disabled lógico no lo detecta -->
            <div class="col-md-6 mt-36">
                <label for="nacionalidad">Nacionalidad</label>
                <ng-container *ngIf="datosPersonalesResponse?.idNacionalidad === 47; else selectHabilitado">
                    <select name="nacionalidad" formControlName="nacionalidad" disabled>
                        <option *ngFor="let nacionalidad of nacionalidades" [value]="nacionalidad.id">
                            {{ nacionalidad.nombre }}
                        </option>
                    </select>
                </ng-container>
                <ng-template #selectHabilitado>
                    <select name="nacionalidad" formControlName="nacionalidad"
                        [class.selectInvalido]="datosPersonalesForm.get('nacionalidad').invalid && datosPersonalesForm.get('nacionalidad').touched"
                        placeholder="Seleccionar">
                        <option value="0">Seleccionar</option>
                        <option *ngFor="let nacionalidad of nacionalidades" [value]="nacionalidad.id">
                            {{ nacionalidad.nombre }}
                        </option>
                    </select>
                </ng-template>
                <p *ngIf=" (datosPersonalesForm.get('nacionalidad').touched && datosPersonalesForm.get('nacionalidad') === null)
                    || (datosPersonalesForm.get('nacionalidad').touched && datosPersonalesForm.get('nacionalidad').invalid)"
                    class="mensajeError">
                    {{ mensajeErrorDatosPersonales.REQUIRED_COUNTRY_MESSAGE }}
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mt-36">
                <label for="correoElectronico">Correo electrónico</label>
                <input type="text" name="correoElectronico" formControlName="correoElectronico"
                    placeholder="contacto@gmail.com" autocomplete="off" appMaxLength="40" [(ngModel)]="correo"
                    [class.inputInvalido]="datosPersonalesForm.get('correoElectronico').invalid && datosPersonalesForm.get('correoElectronico').touched"
                    required />
                <p *ngIf="(datosPersonalesForm.get('correoElectronico').touched && datosPersonalesForm.get('correoElectronico') === null)
                    || (datosPersonalesForm.get('correoElectronico').touched && datosPersonalesForm.get('correoElectronico').invalid)"
                    class="mensajeError">
                    {{ mensajeErrorDatosPersonales.REQUIRED_EMAIL_MESSAGE }}
                </p>
            </div>
            <div class="col-md-6 mt-36">
                <label for="telefono">Teléfono</label>
                <span class="prefijo">+56</span>
                <input appNumeros type="text" class="pre-input" name="telefono" formControlName="telefono"
                    placeholder="Ingresar hasta 9 digitos" autocomplete="off" appMaxLength="9" [(ngModel)]="telefono"
                    [class.inputInvalido]="datosPersonalesForm.get('telefono').invalid && (datosPersonalesForm.get('telefono').touched || datosPersonalesForm.get('telefono').dirty)"
                    required />
                <p *ngIf="(datosPersonalesForm.get('telefono').touched || datosPersonalesForm.get('telefono').dirty)
                    && ( datosPersonalesForm.get('telefono').hasError('length') || datosPersonalesForm.get('telefono').hasError('pattern') )"
                    class="mensajeError">
                    {{ mensajeErrorDatosPersonales.INVALID_PHONE_MESSAGE }}
                </p>
                <p *ngIf="(datosPersonalesForm.get('telefono').touched || datosPersonalesForm.get('telefono').dirty)
                    && datosPersonalesForm.get('telefono').hasError('required')" class="mensajeError">
                    {{ mensajeErrorDatosPersonales.REQUIRED_PHONE_MESSAGE }}
                </p>
            </div>
        </div>
        <app-messages *ngIf="showInfoMessage" class="informativo mt-30 mb-16 p-16"
            message="Para continuar <strong>revisa que tus datos de correo electrónico y teléfono estén correctos</strong>, tu solicitud quedará asociada a ellos. Además, en caso de dudas que puedas tener durante el proceso nos podremos comunicar contigo.">
        </app-messages>
        <div class="row box-button">
            <div class="col-md-12">
                <button class="btn-primary-tbk" type="submit" value="Continuar" (click)="Continuar($event)"
                    [disabled]="!datosPersonalesForm.valid && !formChanged">
                    <div *ngIf="loading" class="spinner-border text-light" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <div *ngIf="!loading">Guardar</div>
                </button>
            </div>
        </div>
    </ng-container>

</mat-expansion-panel>